export const normalizeClientStatus = (rawStatus) => {
    if (!rawStatus) return "";
    const trimmed = String(rawStatus).trim();
    return trimmed.toLowerCase() === "in-active" ? "Inactive" : trimmed;
};

export const isAdminRole = (userInfoString) => {
    if (!userInfoString) return false;
    try {
        const parsed = typeof userInfoString === "string" ? JSON.parse(userInfoString) : userInfoString;
        if (typeof parsed === "number") {
            return parsed === 1 || parsed === 3;
        }
        const roleId = Number(parsed?.roleID ?? parsed?.RoleID ?? 0);
        return roleId === 1 || roleId === 3;
    } catch {
        return false;
    }
};

export const NO_DATA_FOUND_MSG = "Failed to fetch user list: No data found.";

export const isDeleteAccountSuccess = (response) =>
    response === true || response === "deleted" || response?.code === 200 || response?.Code === 200;

export const resolveDeleteErrorMessage = (response, fallbackMessage = NO_DATA_FOUND_MSG) => {
    if (typeof response === "string" && response.trim()) {
        return response;
    }
    return response?.responseMsg || response?.ResponseMsg || fallbackMessage;
};
